<template>
    <div class="sustainable-component wage-result-largeanalysis">
        <!--
    <div class="bg-success mb-3 p-3 rounded">vue component wage-result-largeanalysis</div>
    -->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    <table class="table table-light table-hover table-striped">
                        <thead class="thead-light">
                            <tr>
                                <th>
                                    <v-select bg-color="white" variant="outlined" :items="employeeNumbers" v-model="selectedEmployeeNumber" item-title="name" item-value="value" hide-details density="compact"></v-select>
                                </th>
                                <th>
                                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="getJobpositions()" v-model="selectedPositionName" item-title="name" item-value="value" hide-details density="compact"></v-select>
                                </th>
                                <th>
                                    <v-select bg-color="white" variant="outlined" :items="sexes" v-model="selectedSex" item-title="name" item-value="value" hide-details density="compact"></v-select>
                                </th>
                                <th><a href="javascript:void(0)" @click="doSort('Grundlon')">GLD kr</a></th>
                                <th><a href="javascript:void(0)" @click="doSort('BlocklonGodk')">BLD kr</a></th>
                                <th><a href="javascript:void(0)" @click="doSort('Individlon')">ILD kr</a></th>
                                <th><a href="javascript:void(0)" @click="doSort('RorligLon')">RLD kr</a></th>
                                <th><a href="javascript:void(0)" @click="doSort('Salary')">Lön kr</a></th>
                                <th><a href="javascript:void(0)" @click="doSort('BlocklonNasta')">BLD bsl utv</a></th>
                                <th><a href="javascript:void(0)" @click="doSort('BLDUtv')">BLD utv kr</a></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(resultRow, index) in largeSalaryAnalysisResult" :key="index">
                                <td>{{resultRow.EmployeeNumber}}</td>
                                <td>{{resultRow.JobPositionName}}</td>
                                <td>{{resultRow.Sex}}</td>
                                <td><span v-decimal-text.max2="resultRow.BaseSalary"></span></td>
                                <td><span v-decimal-text.max2="resultRow.BlockSalary"></span></td>
                                <td><span v-decimal-text.max2="resultRow.IndividualSalary"></span></td>
                                <td><span v-decimal-text.max2="resultRow.DynamicSalary"></span></td>
                                <td><span v-decimal-text.max2="resultRow.Salary"></span></td>
                                <td><span v-decimal-text.max2="resultRow.BlockSalaryNext"></span></td>
                                <td><span v-decimal-text.max2="resultRow.BLDDev"></span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-4">
                    <p><a href="javascript:void(0)" @click="printSalaryAnalysis">Visa löneanalys-rapport</a></p>
                    <p><a @click="downloadExcel" href="javascript:void(0)">Exportera löneanalys till Excel</a></p>
                    <p><a href="javascript:void(0)" @click="toggleSaveOption">Spara löneanalys</a></p>
                    <div class="container-fluid p-0" v-if="enableSave == true">
                        <div class="row">
                            <div class="col-6">
                                <v-text-field v-bind:disabled="disabled" bg-color="white" label="Namn" :rules="[rules.required]" v-model="fileName" variant="outlined" density="compact"></v-text-field>
                            </div>
                            <div class="col-6">
                                <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="saveAnalysis">
                                    spara
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <p><a @click="showDiagrams" href="javascript:void(0)">Visa diagram</a></p>
                </div>
                <div class="col-12 col-md-8">
                    <table class="table table-light table-hover table-striped">
                        <thead class="thead-light">
                            <tr>
                                <th></th>
                                <th>GLD kr</th>
                                <th>BLD kr</th>
                                <th>ILD kr</th>
                                <th>RLD kr</th>
                                <th>Lön kr</th>
                                <th>BLD bsl utv</th>
                                <th>BLD utv kr</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(resultRow, index) in largeAnalysisResultSums" :key="index">
                                <td><span v-decimal-text.max2="resultRow.SumText"></span></td>
                                <td><span v-decimal-text.max2="resultRow.BaseSalary"></span></td>
                                <td><span v-decimal-text.max2="resultRow.BlockSalary"></span></td>
                                <td><span v-decimal-text.max2="resultRow.IndividualSalary"></span></td>
                                <td><span v-decimal-text.max2="resultRow.DynamicSalary"></span></td>
                                <td><span v-decimal-text.max2="resultRow.Salary"></span></td>
                                <td><span v-decimal-text.max2="resultRow.BlockSalaryNext"></span></td>
                                <td><span v-decimal-text.max2="resultRow.BLDDev"></span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" v-if="diagramsVisible == true">
                <div class="col-12">
                    <v-expansion-panels variant="accordion" class="theme-orange">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="orange">
                                Genomsnittslön
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <img v-bind:src="getAverageSalaryUrl()" width="400" />
                                        </div>
                                    </div>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-title color="orange">
                                Genomsnittslön, olika lönedelar
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>

                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <img v-bind:src="GetAverageDifferentUrl()" style="width:100%" />
                                        </div>
                                    </div>
                                </div>


                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </div>

            </div>

        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    //import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import ValidationService from "../../Services/ValidationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import WageService from "../../Services/WageService";
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'wage-result-largeanalysis',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            showDiagrams() {
                this.diagramsVisible = true;
            },
            doSort(sortBy) {
                this.sortBy = sortBy;
            },
            async loadLargeAnalysis() {
                this.loading++;
                try {
                    this.largeSalaryAnalysisResult = await WageService.getLargeSalaryAnalysis(this.selectedEmployeeNumber, this.selectedPositionName, this.selectedSex, this.sortBy);

                    var tmpEmployeeNumbers = [];
                    tmpEmployeeNumbers.push({ name: "Anst. nr.", value: null })
                    tmpEmployeeNumbers.push({ name: "Alla", value: "" })
                    for (var i = 0; i < this.largeSalaryAnalysisResult.length; i++) {
                        tmpEmployeeNumbers.push({ name: this.largeSalaryAnalysisResult[i].EmployeeNumber, value: this.largeSalaryAnalysisResult[i].EmployeeNumber })
                    }
                    this.employeeNumbers = tmpEmployeeNumbers;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadLargeAnalysisSums() {
                this.loading++;
                try {
                    this.largeAnalysisResultSums = await WageService.getLargeSalaryAnalysisSumSalary(this.selectedEmployeeNumber, this.selectedPositionName, this.selectedSex);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async downloadExcel() {
                location.href = '/WageSettingsExcel/ExportLargeSalaryAnalysis';
            },
            getJobpositions() {
                var tmpPositions = [{ name: "Alla", value:"" }];
                for (var i = 0; i < this.internalModel.JobPositions.length; i++) {
                    tmpPositions.push({ name: this.internalModel.JobPositions[i].Name, value: this.internalModel.JobPositions[i].Name })
                }
                return tmpPositions;
            },
            getFilteredUrl() {
                
                var selEmployeeNumber = this.selectedEmployeeNumber;
                if (selEmployeeNumber == "null" || selEmployeeNumber == null)
                    selEmployeeNumber = "";

                var selJobPositionName = this.selectedPositionName;
                if (selJobPositionName == "null" || selJobPositionName == null)
                    selJobPositionName = "";

                var selSex = this.selectedSex;
                if (selSex == "null" || selSex == null)
                    selSex = "";

                var selSortBy = this.sortBy;
                if (selSortBy == "null" || selSortBy == null)
                    selSortBy = "";

                var ret = "employeeId=" + selEmployeeNumber + "&jobPositionName=" + selJobPositionName + "&sex=" + selSex + "&sortBy=" + selSortBy;
                return ret;
            },
            getAverageSalaryUrl() {
                return "/WageSettingsChart/GetAverageSalary?" + this.getFilteredUrl();
            },
            GetAverageDifferentUrl() {
                return "/WageSettingsChart/GetAverageDifferent?" + this.getFilteredUrl();
            },
            async printSalaryAnalysis() {
                this.newWindow = window.open('/wagesettingsprint/printSalaryAnalysis?' + this.getFilteredUrl(), '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            toggleSaveOption() {
                this.enableSave = !this.enableSave;
            },
            async saveAnalysis() {
                this.loading++;
                try {
                    await WageService.saveLargeSalaryAnalysis(this.fileName);
                    this.displaySnackBar("Sparat");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },

        },
        data() {
            return {
                rules: ValidationService.rules(),
                sexes: [{ name: "Kön", value: null }, { name: "Alla", value: "" }, { name: "Man", value: "Man" }, { name: "Kvinna", value: "Kvinna"}],
                largeSalaryAnalysisResult: [],
                largeAnalysisResultSums: [],
                diagramsVisible: false,
                fileName:null,
                employeeNumbers: [{ name: "Anst. nr.", value: null }],
                selectedEmployeeNumber: null,
                selectedPositionName: null,
                selectedSex: null,
                sortBy: null,
                enableSave: false,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedEmployeeNumber: function () {
                this.loadLargeAnalysis();
                this.loadLargeAnalysisSums();
            },
            selectedPositionName: function () {
                this.loadLargeAnalysis();
                this.loadLargeAnalysisSums();
            },
            selectedSex: function () {
                this.loadLargeAnalysis();
                this.loadLargeAnalysisSums();
            },
            sortBy: function () {
                this.loadLargeAnalysis();
                this.loadLargeAnalysisSums();
            },
            
            
        },
        mounted() {
            this.internalModel = this.model;
            this.loadLargeAnalysis();
            this.loadLargeAnalysisSums();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
